import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UsersApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export type DeleteUserGroupParams = {
  userGroupId: number
}

export const useMutationDeleteUserGroup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: DeleteUserGroupParams) => {
      return await baseClient
        .getApi(UsersApi)
        .deleteUserGroup({
          userGroupId: params.userGroupId,
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.userGroupsAll })
    },
  })
}
